






























































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";


import firebase from "firebase/app";
import {LoginState} from "@/store/modules/user";
import LoginManager from "@/script/login";
import {UrlHelper} from "@/script/util";

import {validationMixin} from "vuelidate";
import {required, minLength, maxLength} from "vuelidate/lib/validators";
import {helpers} from "vuelidate/lib/validators";

const emailValidator = helpers.regex(
    "emailValidator",
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
);

const pwdValidator = helpers.regex(
    "pwdValidator",
    /^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W)).{6,20}$/
);
@Component({
    components: {},
    mixins: [validationMixin],
    validations: {
        form: {
            email: {
                required,
                emailValidator,
            },
            password: {
                required,
                pwdValidator,
                minLength: minLength(6),
                maxLength: maxLength(20),
            },
        },
    },
})
export default class Login extends Vue {
    private redirect: string = "";
    private form = {email: "", password: ""};

    // private googleRegister: boolean = false;
    // private isClickedLoginBtn: boolean = false;
    private isGoolgeLoginDone: boolean = false;
    // private isClickedRegisterTab: boolean = false;

    // private googleBtn: string = "img/btn_google_signin_dark_normal_web.png";


    // vuelidate
    validateState(name) {
        const {$dirty, $error} = this.$v.form[name]!;
        return $dirty ? !$error : null;
    }

    //login enter key event
    checkLogin(event) {
        if (event.which === 13) {
            this.login();
        }
    }

    async login() {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
            return;
        }

        try {
            const result = await firebase
                .auth()
                .signInWithEmailAndPassword(
                    this.form.email,
                    this.form.password
                );

            if (result.user) {
                const token = await firebase.auth().currentUser!.getIdToken();
                this.$store.commit("idToken", token);

                const result = await Vue.$api.user();
                // if( result.error && result.error && result.error.message === '잘 못 된 유저 아이디입니다' ) {
                if (result?.error?.code === 20001) {
                    // alert( this.$t('login.joinError') as string );
                    this.$store.commit("loginState", LoginState.no_user);

                    // this.googleRegister = false;
                    // await this.$router.replace("/joinEmailContinue");
                    return;
                }

                const {user} = result;
                this.$store.commit("user", user);
                await LoginManager.login();
                // this.$store.commit('loginState', LoginState.login );

                if (this.$store.getters.redirectRouter) {
                    const router = this.$store.getters.redirectRouter;
                    this.$store.commit("redirectRouter", null);
                    await this.$router.replace(router);
                }
                else if (this.$store.getters.redirectUrl) {
                    const url = this.$store.getters.redirectUrl;
                    this.$store.commit("redirectUrl", null);
                    window.location.href = url;
                }
                else {
                    await this.$router.replace('/');
                }
            }
        }
        catch (e) {


            const code = e.code;
            // console.log(code);
            if (code) {
                switch (code) {
                    case "auth/wrong-password":
                        this.$modal.show('wrongInfo')
                        // this.passwordError = '잘못된 비밀번호 입니다. 다시 입력하세요.'
                        break;
                    case "auth/user-not-found":
                        this.$modal.show('noUser')
                        // alert(this.$t('login.firebaseError.userNotFound') as string);
                        break;
                    default:
                        // alert('잠시 후 다시 시도해주세요.');
                        break;
                }
            }
        }
    }

    async mounted() {

        //로그인
        const loginState = await this.$store.dispatch("loginState");
        switch (loginState) {
            case LoginState.login:
                // if(this.redirect) {
                //     window.location.href = this.redirect;
                // }
                // else {
                //     await this.$router.replace('/');
                // }

                await this.$router.replace('/');
                break;
        }

        this.redirect = UrlHelper.getParameterByName("z_redirect_url");

        if (this.redirect) {
            // console.log(this.redirect);
            this.$store.commit("redirectUrl", this.redirect);
        }
    }


    async google() {
        await this.$store.dispatch("loginState");

        const provider = new firebase.auth.GoogleAuthProvider();
        const result: any = await firebase.auth().signInWithPopup(provider);



        if (result.user) {
            const token = await firebase.auth().currentUser?.getIdToken();
            this.$store.commit("idToken", token);
            Vue.$api.user()
                .then(async (res: any) => {
                    const {user} = res;
                    this.$store.commit("user", user);
                    await LoginManager.login();
                    // this.$store.commit('loginState', LoginState.login );
                    // await this.$router.replace('/');
                    if (this.$store.getters.redirectRouter) {

                        const router = this.$store.getters.redirectRouter;
                        this.$store.commit("redirectRouter", null);
                        await this.$router.replace(router);
                    }
                    else if (this.$store.getters.redirectUrl) {
                        const url = this.$store.getters.redirectUrl;
                        this.$store.commit("redirectUrl", null);
                        window.location.href = url;
                    }
                    else {

                        await this.$router.push(`/${this.i18n.locale}/channel/${this.$store.getters.user.channel_id}/timeline`
                        );
                    }

                })
                .catch((err: any) => {
                    if (err.error.code === 20001) {
                        this.$store.commit("loginState", LoginState.no_user);
                        this.$router.replace(`/${this.i18n.locale}/googleJoin`);
                        return;
                    }
                })

            // const result = await Vue.$api.user();
            // if( result.error && result.error && result.error.message === '잘 못 된 유저 아이디입니다' ) {


        }
    }


    findPwd() {
        document.getElementById("forgotPwdBtn")!.click();
        (this.$refs.forgotPwdBtn as any).click();
    }

    googleRegisterDone() {
        (this.$refs.registerBtn as any).click();
        this.isGoolgeLoginDone = !this.isGoolgeLoginDone;
    }

    closeModal() {
        this.$modal.hide('noUser')
    }
}
